import { Heading } from "@/components/heading/Heading";
import { HeadingSection } from "@/components/heading/HeadingSection";
import { type Opportunity } from "@repo/api";
import { ListView, Text } from "@repo/skapa";
import { t } from "@repo/translation";
import { ElementsContainer } from "@repo/ui";
import { hasItems } from "@repo/utils";

import { InlineNoteInput } from "./InlineNoteInput";
import { NoteItem } from "./NoteItem";
import { useNotes } from "./useNotes";

const RECENT_NOTES_COUNT = 3;

interface CompactNotesSectionProps {
  opportunity: Opportunity;
}

// Quickview-friendly notes: inline create + recent notes with inline edit and edit audit trail.
export const CompactNotesSection = ({
  opportunity,
}: CompactNotesSectionProps) => {
  const { pinnedNotes, unpinnedNotes } = useNotes(opportunity);
  const recentNotes = [...pinnedNotes, ...unpinnedNotes]
    .sort(
      (a, b) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    )
    .slice(0, RECENT_NOTES_COUNT);

  return (
    <ElementsContainer>
      <HeadingSection>
        <Heading textStyle="Heading.S">{t("label.notes")}</Heading>
      </HeadingSection>
      <InlineNoteInput opportunityId={opportunity.id} />
      {hasItems(recentNotes) ? (
        <ListView id="quickview-notes-list" size="small" showDivider={false}>
          {recentNotes.map((note) => (
            <NoteItem key={note.id} note={note} />
          ))}
        </ListView>
      ) : (
        <Text>{t("prompt.no_notes")}</Text>
      )}
    </ElementsContainer>
  );
};
